__turbopack_context__.v({
  "caption": "rJelUa_caption",
  "marquee": "rJelUa_marquee",
  "marqueeInner": "rJelUa_marqueeInner",
  "marqueeItem": "rJelUa_marqueeItem",
  "root": "rJelUa_root",
});
